module.exports = __webpack_public_path__ + "assets/img/logitech-astrogaming-w960.722a51e8.webp";